import { assetDictionary } from "@dinahmoe/dmafjs-assetloader";

import { webAudioContext } from "./webaudio_context";
import { webAudioUtils } from "./webaudio_utils";
import { NodeHtml } from "./node_html";

class SamplerHtml extends NodeHtml {
  handlers = this.extendParentHandlers({
    volume: { handler: this.setVolume, type: "float", default: 0, min: -80, max: 12 },
  });

  setProps(dnode) {
    const output = webAudioContext.context.createGain();
    output.gain.value = webAudioUtils.dbToJs(dnode.props.volume);
    dnode.output = output;

    super.setProps(dnode);
  }

  #createSample({ assetId, playbackRate }) {
    const amp = webAudioContext.context.createGain();
    const source = webAudioContext.context.createBufferSource();

    source.buffer = assetDictionary.get("assets.buffer." + assetId);
    source.playbackRate.value = playbackRate;
    source.connect(amp);

    return {
      source,
      amp,
    };
  }

  #getSeconds(ms) {
    return ms / 1000;
  }

  playNote(dnode) {
    const {
      attack,
      assetId,
      playbackRate,
      duration,
      time,
      velocity,
      ampRange,
      release,
      ignoreNoteOff,
    } = dnode.props;

    const sample = this.#createSample.call(this, { assetId, playbackRate });
    sample.amp.connect(dnode.output);

    const vol = webAudioUtils.dbToJs(-ampRange * ((127 - velocity) / 127));

    if (attack > 0) {
      sample.amp.gain.setValueAtTime(0, time);
      sample.amp.gain.linearRampToValueAtTime(
        vol,
        time + this.#getSeconds(attack)
      );
    } else {
      sample.amp.gain.value = vol;
    }

    sample.source.start(time);

    if (!ignoreNoteOff) {
      const endTime = time + this.#getSeconds(duration);
      const releaseSeconds = this.#getSeconds(release);

      if (releaseSeconds > 0) {
        sample.amp.gain.setValueAtTime(vol, endTime);
        sample.amp.gain.linearRampToValueAtTime(0, endTime + releaseSeconds);
      }

      sample.source.stop(endTime + releaseSeconds);
    }

    sample.source.addEventListener("ended", function () {
      if (sample && sample.amp) {
        sample.amp.disconnect();
        delete sample.amp;
      }
    });
    //not sure soundsPlaying is needed
    dnode.soundsPlaying.push(sample);
  }

  setVolume(dnode) {
    dnode.output.gain.value = webAudioUtils.dbToJs(dnode.props.volume);
  }
}

const samplerHtml = new SamplerHtml("webaudio:sampler");
export { samplerHtml, SamplerHtml };
